import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiDocType } from "./types";

interface StockDocTypesListResponse {
    stockDocTypes: ApiDocType[];
}

/**
 * Транспортный слой OMP — типы складских документов.
 */
export const stockDocTypesApi = {
    /**
     * Возвращает полный справочник типов складских документов.
     * Запрос уходит в endpoint `stock/stockDocTypes.loadAll`.
     */
    loadAll: async (config?: RequestConfig): Promise<ApiDocType[]> => {
        const data = await ompApiClient.postOmega<StockDocTypesListResponse>("stock/stockDocTypes.loadAll", {}, config);
        return data.stockDocTypes;
    },
} as const;
